import React from 'react';
import Table from '../../components/common/Table';
import { NoteTypeDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface NoteTypeTableProps {
  data: NoteTypeDTO[];
  handleEdit: (row: NoteTypeDTO) => void;
  handleDelete: (row: NoteTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const NoteTypeTable: React.FC<NoteTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'Colour',
          key: 'colour',
          render: (row: NoteTypeDTO) => (
            <div className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{
                  backgroundColor: row.colourGrading?.colour ?? '#ffffff',
                }}
              />
              <span className="text-sm text-slate-600 dark:text-slate-300">
                {row.colourGrading?.title ?? '-'}
              </span>
            </div>
          ),
        },
        {
          label: 'Position',
          key: 'displayPosition',
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: NoteTypeDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default NoteTypeTable;
